import {requestWechat} from "../app/requestForWechat";

//账号管理接口
function accountMgr(method='http', bizContent={}) {
    return requestWechat.request({
        url: '/toodo/home/wxAccountMgr?token='+requestWechat.getToken(),
        data: {
            method,
            bizContent
        }
    })
}

//获取带参二维码
function getQrcode(actId,    //活动ID  (integer)
                   userId,   //被投票的用户编号  (bigInteger)
                   title,    //标题
                   describe, //描述
                   picUrl,   //图片url
                   linkUrl   //投票url
                    ) {
    let p = new Promise((resolve,reject)=>{
        let bizContent = {
            actId,    //活动ID  (integer)
            userId,   //被投票的用户编号  (bigInteger)
            title,    //标题
            describe, //描述
            picUrl,   //图片url
            linkUrl   //投票url
        }
        accountMgr("/getQrcode", bizContent).then(res=>{
            resolve(res)
        }).catch(err=>{
            reject({code: err.code, msg:err.msg})
        }).finally(()=>{})
    })
    return p;
}

//获取用户openId, unionId
function getUserInfo(userId   //用户id(分享链接中带的用户id)  (integer)
) {
    let p = new Promise((resolve,reject)=>{
        let bizContent = {
            userId   //用户id(分享链接中带的用户id)  (integer)
        }
        accountMgr("/getUserInfo", bizContent).then(res=>{
            resolve(res)
        }).catch(err=>{
            reject({code: err.code, msg:err.msg})
        }).finally(()=>{})
    })
    return p;
}

//获取APP token
function getWXLoginToken(
    actId,
    userId,   //用户id(分享链接中带的用户id)  (integer)
    infoId,
    signCode,
    linkUrl,
) {
    let p = new Promise((resolve,reject)=>{
        let bizContent = {
            actId,
            userId,   //用户id(分享链接中带的用户id)  (integer)
            infoId,
            signCode,
            linkUrl,
        }
        accountMgr("/getWXLoginToken", bizContent).then(res=>{
            resolve(res)
        }).catch(err=>{
            reject({code: err.code, msg:err.msg})
        }).finally(()=>{})
    })
    return p;
}

export const wxAccountMgr = {
    getQrcode,
    getUserInfo,
    getWXLoginToken,
}